import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { AuthenticationServicesService } from './api-module/services/authentication/authentication-services.service';
import { UtilitiesService } from './api-module/services/utilities/utilities.service';
import { NotificationsService } from './dispatcher/notifications.service';
import { MessageService } from 'primeng/api';
//  import { Growl } from 'primeng/primeng'; // we replace it with toast message
import { ActivatedRoute, Event, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AppState } from './store/refresh-rate.reducer';
import { Store } from '@ngrx/store';
import { RefreshRateService } from './services/refresh-rate.service';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {
  title = 'app';
  menuItemToggle: boolean;
  roles: string[];
  toggleFullWidth: any;
  message: any;
  growlMessage = [];
  // @ViewChild('growl', { static: false }) growl: Growl; // type is growl 
isSuccessOrFailUpaymentUrl: boolean=false;
  loading: boolean = false;
  /////// reload upon web connected
  // public isOnline: boolean;
  // public showConnectionStatus: boolean;
  // private showConnectionStatusSub: Subscription;
  // private showConnectionStatusTimer: Observable<any>;


  // @HostListener('window:offline', ['$event']) onOffline() {
  //   this.isOnline = false;
  //   this.showConnectionStatus = true;
  //   if (this.showConnectionStatusSub) {
  //     this.showConnectionStatusSub.unsubscribe();
  //   }
  // }


  // @HostListener('window:online', ['$event']) onOnline() {
  // this.isOnline = true;
  // this.showConnectionStatus = true;
  // this.showConnectionStatusSub = this.showConnectionStatusTimer.subscribe(() => {
  // this.showConnectionStatus = false;
  // this.showConnectionStatusSub.unsubscribe();
  // window.location.reload();
  // });
  // }

  ///////////////////////////////////////

  constructor(private authService: AuthenticationServicesService,
    private utilities: UtilitiesService,
    private notificationsService: NotificationsService,
    private messageService: MessageService,
    private router: Router,
    private modalService: NgbModal,
    private refreshRateService: RefreshRateService,
    private store: Store<AppState>,
    private translateService: TranslateService,
    private route:ActivatedRoute
  
  ) {
    const currentURL = window.location.href;
    if(currentURL.includes('upayment?') && currentURL.includes('&Result') && currentURL.includes('TrackID')) {
      this.isSuccessOrFailUpaymentUrl=true;
    }
    else{ this.isSuccessOrFailUpaymentUrl=false;}
   
    this.router.events.subscribe((event: Event) => {
      switch (true) {
        case event instanceof NavigationStart: {
          this.loading = true;
          break;
        }

        case event instanceof NavigationEnd:
        case event instanceof NavigationCancel:
        case event instanceof NavigationError: {
          this.loading = false;
          break;
        }
        default: {
          break;
        }
      }
    });
  }

  ngOnInit() {
    this.notificationsService.requestPermission()
    // this.notificationsService.receiveMessage()
    //   .subscribe(
    //     (msg: any) => {

    //       console.log('subscribeToNotification', msg)



    //       // this.utilities.setGrowlMessage({
    //       //   severity: 'success',
    //       //   summary: 'Message',
    //       //   detail: msg.notification.body
    //       // });
    //     }, err => console.error(err)
    //   );


    this.subscribeToNotification();
    // this.message = this.notificationsService.currentMessage
    this.messageService.clearObserver.subscribe((res) => {
      console.log("FromclearObserverInAppComp", res)
      if (res != 'blockItem') {
        // this.growl.value = null;
      }
    });
    this.messageService.messageObserver.subscribe((m: any) => {

      if (m && m.key && m.key == 'blockItem') {
        // this.growl.value = null;
      } else {
        // this.growl.value = [m];
      }
    });
    this.roles = [];
    this.authService.userRoles.subscribe((roles) => {
      this.roles = roles || [];
    });
    this.subscribeToGrowlMessage();
    this.refreshRateService.setSettings();
  }

  subscribeToNotification() {
    window.addEventListener('storage', (event) => {
      console.log("FromsubscribeToNotificationInAppComp", localStorage)
      if (event.storageArea == localStorage) {
        let token = localStorage.getItem('AlghanimCurrentUser');
        console.log("FromsubscribeToNotificationInAppComp", token)
        if (token == undefined) {
          this.modalService.dismissAll();
          setTimeout(() => {
            // this.growl.value = null;
          }, 0);
          this.router.navigate(['login']);
        }
      }
    });

  }


  subscribeToGrowlMessage() {
    this.utilities.growlMessage.subscribe((message) => {
      this.growlMessage.push(message);
    });
  }
}
